import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationExtras } from '@angular/router';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';
import { IIcon } from '../icon/icon.component';

export interface IRouter {
  icon?: IIcon;
  label?: string;
  route: string[];
  navigationExtras?: NavigationExtras;
  external?: boolean;
  disabled?: boolean;
  identifier?: string;
  e2eId?: string;
  trackingObject?: ITrackingObject;
  trackingAction?: ITrackingAction;
  trackingAdditionalProperties?: any;
}

export enum AlignmentEnum {
  left = 'left',
  center = 'center',
  right = 'right',
}

/**
 * Style link like button
 * - 'plain' is no style applied
 * - 'default' and 'emphasis' exist in design system
 */
export type RouterLinkButtonStyle =
  | 'plain'
  | 'default'
  | 'emphasis'
  | 'tertiary'
  | 'default-reversed';

@Component({
  selector: 'i2g-router-link',
  templateUrl: 'router-link.component.html',
  styleUrls: ['router-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouterLinkComponent implements OnInit {
  @Input() type = '';
  @Input() label: string;
  @Input() hideLabel: boolean;
  @Input() route: string | string[];
  @Input() navigationExtras: NavigationExtras;
  @Input() disabled: boolean;
  @Input() icon: IIcon;
  @Input() e2eId: string;
  @Input() alignment: AlignmentEnum = AlignmentEnum.left;
  @Input() tabIndex: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;
  @Input() trackingAdditionalProperties: any;
  @Input() buttonStyle: RouterLinkButtonStyle;
  @Input() wordWrap = false;

  @Output() linkClick: EventEmitter<void> = new EventEmitter<void>();

  classNameButtonStyle: string;

  constructor(private _ngZone: NgZone) {}

  ngOnInit() {
    this.classNameButtonStyle = this.buttonStyle
      ? `${this.buttonStyle}-button-style`
      : '';
  }

  onClick(evt: MouseEvent) {
    // fix for APPS-763
    // https://stackoverflow.com/questions/48341085/angular-change-detection-not-triggering-on-router-navigate
    this._ngZone.run(() => {
      if (this.disabled) {
        evt.preventDefault();
      } else {
        this.linkClick.emit();
      }
    });
  }
}
